module.exports = __webpack_public_path__ + "static/media/icon-cliente.20c9b0db.svg";